import styled from "styled-components"

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export default Container



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/Container.js